export const getCheckoutInput = (price_id: string) => {
  return { price_id };
};
